import { Button } from '@crm/ui';
import { UserPlus } from 'lucide-react';
import { useState } from 'react';
import { useCustomers } from '@/modules/customers/api';
import { useBookingMode } from '../../booking-mode';
import { CustomerIdentify } from './customer-identify';
import { SearchList } from './search-list';
import type { AppointmentWizard } from './use-appointment-wizard';

/**
 * Passo 1: quem sera atendido.
 *
 * Na pagina publica nao ha busca - a pessoa se identifica pelo WhatsApp. No
 * sistema a busca continua, com o mesmo cadastro rapido ao lado para quem
 * ligou agora e ainda nao esta na base.
 */
export function StepCustomer({ wizard }: { wizard: AppointmentWizard }) {
  const mode = useBookingMode();
  const [search, setSearch] = useState('');
  const [isRegistering, setRegistering] = useState(false);

  // Sem busca, quem mais volta ao salao aparece primeiro; buscando, o nome
  // manda - a lista tem de acompanhar o que a pessoa esta digitando.
  const customers = useCustomers(
    { page: 1, search: search || undefined, status: 'active', sort: search ? 'name' : 'popular' },
    { enabled: mode === null },
  );

  if (mode || isRegistering) {
    return (
      <div className="space-y-4">
        <p className="text-base text-muted-foreground">
          {mode
            ? 'Informe seu WhatsApp para comecar.'
            : 'Informe o WhatsApp do cliente: se ja houver cadastro, ele aparece aqui.'}
        </p>

        <CustomerIdentify
          onCancel={mode ? undefined : () => setRegistering(false)}
          onIdentified={(customer) => {
            wizard.chooseCustomer({
              id: customer.id,
              name: customer.name,
              phone: customer.phone,
              token: customer.token,
            });
            setRegistering(false);
          }}
        />
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <p className="text-base text-muted-foreground">
        Busque pelo nome ou telefone e toque no cliente.
      </p>

      <SearchList
        placeholder="Buscar cliente"
        isLoading={customers.isLoading}
        emptyLabel={search ? 'Nenhum cliente com esse nome.' : 'Nenhum cliente cadastrado.'}
        onSearch={setSearch}
        // O cadastro anda junto da busca: no fim da lista ele so aparecia
        // depois de rolar todos os clientes.
        action={
          <Button variant="outline" className="h-14 shrink-0" onClick={() => setRegistering(true)}>
            <UserPlus />
            Cadastrar
          </Button>
        }
        items={(customers.data?.data ?? []).map((customer) => ({
          id: customer.id,
          title: customer.name,
          subtitle: customer.phone ?? undefined,
          image: customer.image,
          active: customer.id === wizard.customer?.id,
        }))}
        onSelect={(id) => {
          const chosen = customers.data?.data.find((customer) => customer.id === id);
          if (!chosen) return;

          wizard.chooseCustomer({
            id: chosen.id,
            name: chosen.name,
            phone: chosen.phone,
            image: chosen.image,
          });
        }}
      />
    </div>
  );
}
